<div class="grid field col-12">
  @if (messages.length > 0) {
    <div class="grid field col-12">
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="asMessageSeverity(m.severity)"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }

  @if (!everythingReady) {
    <p-progressSpinner></p-progressSpinner>
  }

  @if (everythingReady) {
    <div class="grid field col-12">
      <div class="col-12 md:col-10"><h2 style="margin-bottom:2px; padding-bottom:0px;">Companies</h2></div>
      @if (isGlobalAdmin()) {
        <div class="col-12 md:col-2">
          <button pButton type="button" (click)="navigateToAddCompany()" style="width:100px; margin-top:20px; float:right; vertical-align:bottom;">
            <i pButtonIcon class="fa fa-plus"></i>
            <span pButtonLabel>Add</span>
          </button>
        </div>
      }
      <div class="col-12">
        <p-table #dt [columns]="cols" [value]="companies" [scrollable]="true"  [paginator]="true" [rows]="25" [resizableColumns]="true" [loading]="!companiesReady" sortField="name">
          >
          <ng-template #header let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field">
                  {{col.header}}
                  @if (col.field != '') {
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  }
                </th>
              }
            </tr>
            <tr>
              @for (col of columns; track col) {
                <th pResizableColumn>
                  @switch (col.field) {
                    @case ('name') {
                      <div>
                        <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;"
                          />
                        </div>
                      }
                      @case ('prefix') {
                        <div>
                          <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;" />
                        </div>
                      }
                      @case ('companyType') {
                        <div>
                          <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" style="width: 100%;" />
                        </div>
                      }
                    }
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template #body let-company>
              <tr>
                <td class="ui-resizable-column">{{company.name}}</td>
                <td class="ui-resizable-column">{{company.prefix}}</td>
                <td>{{company.companyType}}</td>
                <td class="ui-resizable-column">
                  <!-- <div style="display:block">
                  <button pButton
                    icon="far fa-edit"
                    (click)="navigateToDetail(company.id)"
                    style="max-width:35px; margin:auto;">
                  </button>
                  <button pButton
                    icon="far fa-trash-alt"
                    (click)="confirmDelete(company)"
                    style="margin:auto; max-width:35px; margin-left:5px;">
                  </button>
                </div> -->
                <i class="far fa-edit fa-xl" (click)="navigateToDetail(company.id)" style="margin-right:5px;"></i>
                @if (isAdmin(company)) {
                  <i class="far fa-trash-alt fa-xl" (click)="confirmDelete(company)"></i>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template #paginatorleft>
            Showing {{(dt.totalRecords) < 1 ? 0 : ((dt.first ?? 0) + 1)}} to
            {{(dt.totalRecords) > 0 ? (((dt.rows ?? 0) + (dt.first ?? 0)) <= (dt.totalRecords) ? ((dt.rows ?? 0) + (dt.first ?? 0)) :
            (dt.totalRecords)) : 0}} of {{dt.totalRecords}} entries
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>

